import { createFileRoute } from '@tanstack/react-router';

import { AutoVideoCreatorIndexPage } from '@/features/auto-video-creator/routes/IndexPage';

export const Route = createFileRoute('/auto-video-creator/')({
  component: AutoVideoCreatorIndexPage,
});
